import { render, staticRenderFns } from "./KindForm.vue?vue&type=template&id=d79e2e6a"
import script from "./KindForm.vue?vue&type=script&lang=js"
export * from "./KindForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports